/**
 * DocViewSchema for Lazada Listing DocType
 *
 * Read-only detail page for marketplace-synced Lazada product data.
 * Single-tab layout with iPad Settings card sections.
 * All sections use shared marketplace widgets with "Lazada" channel config.
 * Includes Lazada-specific reject reasons section.
 */

import type { DocViewSchema } from "./types";

export const lazadaListingDocViewSchema: DocViewSchema = {
  doctype: "Lazada Listing",
  views: {
    experience: {
      style: "shopify",
      sections: [
        { id: "sync-status", label: "Sync Status", widgetId: "MarketplaceSyncStatusWidget", description: "Lazada" },
        { id: "reject-reasons", label: "Issues", widgetId: "LazadaRejectReasonsWidget", description: "Lazada" },
        { id: "images", label: "Product Images", widgetId: "MarketplaceImagesWidget", description: "Lazada" },
        { id: "product-info", label: "Product Info", widgetId: "MarketplaceProductInfoWidget", description: "Lazada" },
        { id: "pricing", label: "Pricing", widgetId: "MarketplacePricingWidget", description: "Lazada" },
        { id: "package", label: "Package & Inventory", widgetId: "MarketplacePackageWidget", description: "Lazada" },
        { id: "linked-item", label: "Linked Item", widgetId: "MarketplaceLinkedItemWidget", description: "Lazada" },
        { id: "description", label: "Description", widgetId: "MarketplaceDescriptionWidget", description: "Lazada" },
      ],
      tabs: [
        {
          id: "details",
          label: "Details",
          sectionIds: ["sync-status", "reject-reasons", "images", "product-info", "pricing", "package", "linked-item", "description"],
        },
      ],
    },
  },
};
